export const formatLocalDate = value => {
  if (!value) {
    return "";
  }

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const buildAuditLogsApiParams = ({
  page,
  limit,
  action,
  category,
  startDate,
  endDate,
  sortBy,
  sortOrder,
  format
}) => {
  const params = {
    page,
    limit,
    sortBy,
    sortOrder
  };

  if (action) {
    params.action = action;
  }

  if (category) {
    params.category = category;
  }

  const formattedStartDate = formatLocalDate(startDate);
  const formattedEndDate = formatLocalDate(endDate);

  if (formattedStartDate) {
    params.startDate = formattedStartDate;
  }

  if (formattedEndDate) {
    params.endDate = formattedEndDate;
  }

  if (format) {
    params.format = format;
  }

  return params;
};
